import { Form } from '@models/membership/Form'
import { MembershipProfile as MembershipProfileModel } from '@models/membership/MembershipProfile'
import { fetchFormAnswersForEntity } from '@services/membership/FormAnswerService'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileById } from '@store/membership/MembershipProfileReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Empty, Flex, Spin } from 'antd'
import { FC, useEffect, useState } from 'react'
import { FormRender } from '../form/FormRender'
import { MembershipProfileAvatar } from './Avatar'

type Props = SBModelComponent<MembershipProfileModel> & {
  hideAvatar?: boolean
}

/**
 * Despite we're used to pass all resources via the store, here we use local state
 * as this component is likely to be used multiple times on the same page with different ids.
 */
const MembershipProfileDescription: FC<Props> = ({
  id,
  model,
  hideAvatar = false,
}) => {
  const profile = model ?? useAppSelector(selectMembershipProfileById(id!))

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [form, setForm] = useState<Form>()

  useEffect(() => {
    if (!profile) return

    setIsLoading(true)
    fetchFormAnswersForEntity('membership-profile', profile.id)
      .then((data) => {
        setForm(data.data)
      })
      .finally(() => setIsLoading(false))
  }, [profile])

  if (!profile || form?.steps.length == 0) {
    return (
      <Flex
        vertical
        gap={24}
        align="center"
        justify="center"
        style={{ minHeight: 200 }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'Form answers not found'}
        />
      </Flex>
    )
  }

  if (isLoading) {
    return <Spin />
  }

  return (
    <Flex vertical gap={20}>
      {!hideAvatar && (
        <MembershipProfileAvatar
          model={profile}
          showAttributes
          noLinkToDetails
          pictureOpensInModal
        />
      )}
      <FormRender form={form} />
    </Flex>
  )
}

type MembershipProfileDescriptionType = {
  Description: typeof MembershipProfileDescription
}

export { MembershipProfileDescription, type MembershipProfileDescriptionType }
